// unit-tab-content.tsx
import React from "react";
import Units from "../../../../pages/units";
import { useParams } from "react-router-dom";
import { EntityType } from "@propertelligent/client-api";

interface UnitTabContentProps {
  result: any[];
  onUnitAdded?: () => void; // Add the callback prop
  unitRefreshTrigger?: number; // New prop to trigger refresh
}

const UnitTabContent: React.FC<UnitTabContentProps> = ({ result, onUnitAdded, unitRefreshTrigger }) => {
  const { id } = useParams();

  return (
    <Units
      isEntity={true}
      entityId={Number(id)}
      entityTypeId={EntityType.Unit}
      formId="asjkdakd"
      className="no-side-margin"
      onUnitAdded={onUnitAdded} // Pass the callback
      unitRefreshTrigger={unitRefreshTrigger} // Pass the refresh
    />
  );
};

export default UnitTabContent;